module.exports = __webpack_public_path__ + "img/friday-consensus.d35325d0.png";